// Helper mínimo para leer `err.response?.data?.message` sin `any` (constitution.md regla #5).
// Todas las páginas legado de `iam` leen ese mismo campo (`.message`) — no hay divergencia que
// preservar aquí (a diferencia de `workforce/application/apiError.ts`). Cada módulo es dueño de
// su propio helper hasta que exista `shared/api/http.ts` con un tipo de error común (regla #4).

export function apiErrorMessage(err: unknown): string | undefined {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as { response?: { data?: unknown } }).response?.data;
    if (data && typeof data === 'object' && 'message' in data) {
      const message = (data as { message?: unknown }).message;
      return typeof message === 'string' ? message : undefined;
    }
  }
  return undefined;
}
